export const DRAWER_WIDTH_PIXELS = 64
export const APP_BAR_HEIGHT_PIXELS = 64
